export const GET_CART_LOGS_REQUEST = "GET_CART_LOGS_REQUEST";
export const GET_CART_LOGS_SUCCESS = "GET_CART_LOGS_SUCCESS";
export const GET_CART_LOGS_FAILURE = "GET_CART_LOGS_FAILURE";

export const GET_CART_LOG_DETAILS_REQUEST = "GET_CART_LOG_DETAILS_REQUEST";
export const GET_CART_LOG_DETAILS_SUCCESS = "GET_CART_LOG_DETAILS_SUCCESS";
export const GET_CART_LOG_DETAILS_FAILURE = "GET_CART_LOG_DETAILS_FAILURE";

export const CART_LOGS_LOADING = "CART_LOGS_LOADING";

// Action creators for loading state
export const CartLogsLoading = (payload) => ({
  type: CART_LOGS_LOADING,
  payload,
});

// Action creators for getting cart logs
export const getCartLogsRequest = (payload) => ({
  type: GET_CART_LOGS_REQUEST,
  payload,
});

export const getCartLogsSuccess = (payload) => ({
  type: GET_CART_LOGS_SUCCESS,
  payload,
});

export const getCartLogsFailure = (payload) => ({
  type: GET_CART_LOGS_FAILURE,
  payload,
});

// Action creators for getting cart log details
export const getCartLogDetailsRequest = (payload) => ({
  type: GET_CART_LOG_DETAILS_REQUEST,
  payload,
});

export const getCartLogDetailsSuccess = (payload) => ({
  type: GET_CART_LOG_DETAILS_SUCCESS,
  payload,
});

export const getCartLogDetailsFailure = (payload) => ({
  type: GET_CART_LOG_DETAILS_FAILURE,
  payload,
});